import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterLink } from "@angular/router";
import { INavbarData } from "../../models/nav.model";

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: 'menu-item.component.html',
  styleUrl: 'menu-item.component.scss',
})

export class MenuItemComponent implements OnInit{
  @Input() item!: INavbarData;
  @Input() isExpanded: boolean = false;
  @Input() navData!: INavbarData[] | undefined;


  constructor() {}

  ngOnInit() {}

  toggleSubMenu(item: INavbarData) {
    item.isExpanded = !item.isExpanded;
  }
}
